import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { supabase } from '@/integrations/supabase/client';

const OfertaContext = createContext(false);

/** Public, read-only boolean. Errors always preserve the legacy experience. */
export function OfertaProvider({ children }: { children: ReactNode }) {
  const [viradaFeita, setViradaFeita] = useState(false);
  useEffect(() => {
    let active = true;
    const read = async () => {
      const { data, error } = await supabase.rpc('artesa_virada_feita');
      if (active) setViradaFeita(!error && data === true);
    };
    void read();
    const timer = window.setInterval(() => void read(), 60_000);
    return () => { active = false; window.clearInterval(timer); };
  }, []);
  return <OfertaContext.Provider value={viradaFeita}>{children}</OfertaContext.Provider>;
}

export const useOfertaCompleto = () => useContext(OfertaContext);